import { c as _c } from "react/compiler-runtime";
import { Accordion, ShowMore } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { safelySetInnerHTML } from '@udemy-v2/utils';
import { useI18n } from '@udemy-v2/i18n';
import styles from './course-description.module.scss';
interface TargetAudienceProps {
  items: string[];
}
export const TargetAudience: React.FC<TargetAudienceProps> = t0 => {
  const $ = _c(12);
  const {
    items
  } = t0;
  const {
    gettext
  } = useI18n();
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const audienceItems = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("ud-heading-xl", styles["audience-title"]);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== gettext) {
    t3 = gettext("Who this course is for:");
    $[3] = gettext;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <h2 className={t2}>{t3}</h2>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== audienceItems) {
    t5 = <ul className={styles["audience-list"]}>{audienceItems}</ul>;
    $[7] = audienceItems;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={styles.audience} data-purpose="target-audience">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
interface DescriptionProps {
  description?: string;
  targetAudience: string[];
  isCollapsible?: boolean;
  className?: string;
  titleTypography?: 'ud-heading-lg' | 'ud-heading-xl';
  onAccordionToggle?: () => void;
}
export const Description: React.FC<DescriptionProps> = observer(({
  description,
  targetAudience,
  isCollapsible = false,
  className = 'component-margin',
  titleTypography = 'ud-heading-xl',
  onAccordionToggle
}) => {
  const {
    gettext
  } = useI18n();
  if (!description) {
    return null;
  }
  const getAccordionSize = () => {
    switch (titleTypography) {
      case 'ud-heading-lg':
        return 'large';
      case 'ud-heading-xl':
      default:
        return 'xlarge';
    }
  };
  const title = gettext('Description');
  if (!isCollapsible) {
    return <div className={classNames(`ud-text-sm ${className}`, styles.description)} data-purpose="course-description">
                    <h2 data-purpose="description-title" className={classNames(titleTypography, styles['description-header'])}>
                        {title}
                    </h2>
                    <ShowMore ariaLabelExpanded={gettext('Show less description')} ariaLabelCollapsed={gettext('Show more description')} collapsedHeight={221} withGradient={true}>
                        <div {...safelySetInnerHTML({
          descriptionOfCaller: 'description:description',
          html: description
        })} />
                        <TargetAudience items={targetAudience} />
                    </ShowMore>
                </div>;
  }
  return <Accordion size={getAccordionSize()} className={className}>
                <Accordion.Panel title={title} onToggle={onAccordionToggle}>
                    <div className={classNames('ud-text-sm', styles.description)} data-purpose="course-description">
                        <div {...safelySetInnerHTML({
          descriptionOfCaller: 'description:description',
          html: description
        })} />
                        <TargetAudience items={targetAudience} />
                    </div>
                </Accordion.Panel>
            </Accordion>;
});
function _temp(audience, index) {
  return <li key={index}>{audience}</li>;
}